// Row predicates for the manager dashboard tables. Both dashboard tabs filter
// client-side over the same row shape, so the work order number matcher is
// shared between them to keep the two tabs from drifting apart.

function normalize(value) {
  return value == null ? '' : String(value).trim().toLowerCase()
}

// Rows whose value is missing never match an active text filter.
function passesTextFilter(rowValue, filterValue) {
  const query = normalize(filterValue)
  if (!query) return true
  if (rowValue == null) return false

  return String(rowValue).toLowerCase().includes(query)
}

export function filterRowsByWorkOrderNumber(rows, searchValue) {
  const query = normalize(searchValue)
  if (!query) return rows

  return rows.filter((row) => passesTextFilter(row.name, query))
}

// The list filter compares against the section being rendered rather than the
// row, because a row's section membership is what groups it on the Work Order
// Management tab.
function passesListFilter(sectionId, listFilterValue) {
  if (!normalize(listFilterValue)) return true

  return sectionId === listFilterValue
}

function passesOrderTypeFilter(rowOrderType, targetOrderType) {
  if (!normalize(targetOrderType)) return true

  return rowOrderType === targetOrderType
}

export function filterRowsByAdvancedFilters(rows, filterValues, sectionId) {
  const { list, location, city, orderType } = filterValues

  if (!passesListFilter(sectionId, list)) return []

  return rows.filter(
    (row) =>
      passesTextFilter(row.location, location) &&
      passesTextFilter(row.city, city) &&
      passesOrderTypeFilter(row.orderType, orderType)
  )
}

export function appliedFiltersCount(filterValues) {
  const { list, location, city, orderType } = filterValues

  return [list, location, city, orderType].filter((filterValue) =>
    Boolean(normalize(filterValue))
  ).length
}
